import React, { useEffect, useState } from 'react';
import styles from './BillingPlans.module.scss';
import { useNavigate } from "react-router-dom";
import {
    COMPANY_NAME,
    INVOICE_AMOUNT_BASIC_MONTH, INVOICE_AMOUNT_BASIC_YEAR, 
    INVOICE_AMOUNT_STANDARD_MONTH, INVOICE_AMOUNT_STANDARD_YEAR,
    INVOICE_AMOUNT_PREMIUM_MONTH, INVOICE_AMOUNT_PREMIUM_YEAR
} from '../../../common/constants/company';
import { setInvoice } from "../Billing.slice";
import { useAppDispatch } from "../../../hooks/hooks";
import { TBillingState } from "../Billing.interfaces";
import * as Routes from '../../../common/routes';

type PlanKey = 'basic' | 'standard' | 'premium';

interface Feature {
    text: string;
    available: boolean;
}

interface Price {
    key: string;
    value: number;
    currency: string;
    period: string;
}

interface TabSelection {
    key: PlanKey;
    code: string;
    value: number;
}

const plans: {
    key: PlanKey;
    title: string;
    selected: string;
    prices: Price[];
    features: Feature[];
}[] = [
    {
        key: 'basic',
        title: 'Personal',
        selected: 'bm',
        prices: [
            { key: 'by', value: INVOICE_AMOUNT_BASIC_YEAR, currency: 'EUR', period: 'YEAR'},
            { key: 'bm', value: INVOICE_AMOUNT_BASIC_MONTH, currency: 'EUR', period: 'MONTH'}
        ],
        features: [
            { text: 'Scoring page, CMS', available: true },
            { text: 'Pages: Active game, Statistics', available: true },
            { text: 'Widgets', available: false},
            { text: 'Broadcasting', available: false},
            { text: 'Subdomen', available: false },
            { text: 'Development', available: false}
        ]
    },
    {
        key: 'standard',
        title: 'Company',
        selected: 'sm',
        prices: [
            { key: 'sy', value: INVOICE_AMOUNT_STANDARD_YEAR, currency: 'EUR', period: 'YEAR'},
            { key: 'sm', value: INVOICE_AMOUNT_STANDARD_MONTH, currency: 'EUR', period: 'MONTH'}
        ],
        features: [
            { text: 'Scoring page, CMS', available: true },
            { text: 'Pages: all', available: true },
            { text: 'Widgets: all', available: true },
            { text: 'Broadcasting', available: true },
            { text: 'Subdomen', available: false },
            { text: 'Development', available: false }
        ]
    },
    {
        key: 'premium',
        title: 'Bullseye',
        selected: 'pm',
        prices: [
            { key: 'py', value: INVOICE_AMOUNT_PREMIUM_YEAR, currency: 'EUR', period: 'YEAR' },
            { key: 'pm', value: INVOICE_AMOUNT_PREMIUM_MONTH, currency: 'EUR', period: 'MONTH' }
        ],
        features: [
            { text: 'Scoring page, CMS', available: true },
            { text: 'Pages: all', available: true },
            { text: 'Widgets: all', available: true },
            { text: 'Broadcasting', available: true },
            { text: 'Subdomen', available: true },
            { text: 'Development', available: true }
        ]
    },
];

const BillingPlans: React.FC = () => {
    const init: TabSelection[] = plans.map(item => {
        return {
            key: item.key, code: item.selected, value: item.prices.find(price => price.key === item.selected)?.value || 0
        } as TabSelection;
    });
    const [payOptions, setOptions] = useState<TabSelection[]>(init);
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const toBillingInvoice = (option: TabSelection) => {
        const payload: TBillingState = {
            payOption: option.code,
            //companyName: getValues("companyName"),
            //invoiceNumber: getValues("invoiceNumber"),
            companyName: '',
            invoiceNumber: Math.floor(Math.random() * 1000000).toString(),
            invoiceDate: new Date().toISOString()
        }
        dispatch(setInvoice(payload));
        navigate(Routes.BILLING_INVOICES);
    };

    const toBillingPayNow = (option: TabSelection) => {
        console.log('toBillingPayNow option: ', option);
        let payload: TBillingState = {
            payOption: option.code,
            companyName: '',
            invoiceNumber: Math.floor(Math.random() * 1000000).toString(),
            invoiceDate: new Date().toISOString()
        }
        dispatch(setInvoice(payload));
        navigate(Routes.BILLING_PAYNOW);
    };

    const tabClick = (planKey: PlanKey, price: Price) => {
        let index = payOptions.map((o) => o.key).indexOf(planKey);
        let updatedOptions = [...payOptions];
        updatedOptions[index] = { key: planKey, code: price.key, value: price.value };
        setOptions(updatedOptions);
    };

    useEffect(() => {
        document.title = COMPANY_NAME + ' billing plans';
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.pricing}>
                {plans.map(({ key, title, prices, features }, indPlan) => (
                    <div key={key} className={`${styles.card} ${styles[key]}`}>
                        <h3 className={styles.title}>{title}</h3>
                        <ul className={styles.list}>
                            {features.map(({ text, available }, idx) => (
                                <li
                                    key={idx}
                                    className={`${styles.listItem} ${available ? styles.available : styles.unavailable
                                        }`}
                                >
                                    {text}
                                </li>
                            ))}
                        </ul>
                        {prices.map(({ value, currency, period }, index) =>
                            <div className={`${styles.priceTab}`} onClick={() => { tabClick(key, prices[index]) }} style={{
                                width: `${300 / prices.length}px`,
                                top: `${(index + 1) * 27 / prices.length}rem`
                            }}>
                                {value} <span>{currency} / {period}</span>
                            </div>
                        )}
                        {key === 'basic' ?
                            <div className={styles.btnGroup}>
                                <button className={styles.btn} onClick={() => toBillingPayNow(payOptions[indPlan])}>Pay {payOptions[indPlan].value} EUR</button>
                                <button className={styles.btn} onClick={() => toBillingInvoice(payOptions[indPlan])}>Invoice {payOptions[indPlan].value}</button>
                            </div>
                            :
                            <button className={styles.btn} onClick={() => toBillingInvoice(payOptions[indPlan])}>Invoice {payOptions[indPlan].value} EUR</button>
                        }
                    </div>
                ))}
            </div>
        </div>
    );
}

export default BillingPlans;